import { defineMessages } from 'react-intl';


export default defineMessages({
    TYPE_TERM_LABEL: {
        id: 'mtg-common.RateDetailsBanner.rateTypeLabel',
        defaultMessage: 'Rate',
    },
    TYPE_TERM_VALUE: {
        id: 'mtg-common.RateDetailsBanner.deltaPrimeValue',
        defaultMessage: 'Prime {operator} {deltaPrime, number, percent2}',
    },
    RATE_HOLD_LABEL: {
        id: 'mtg-common.RateDetailsBanner.rateHoldLabel',
        defaultMessage: 'Rate hold',
    },
    RATE_HOLD_VALUE: {
        id: 'mtg-common.RateDetailsBanner.rateHoldValue',
        defaultMessage: '{date}',
    },
    RATE_HOLD_TOOLTIP: {
        id: 'mtg-common.RateDetailsBanner.rateHoldTooltip',
        defaultMessage: `The rate hold is the length of time the mortgage provider can hold the interest rate for.
            Submitting this form is the first step to getting your rate held,
            but there will be additional steps required depending on the mortgage provider.`,
    },
    PREPAYMENT_LABEL: {
        id: 'mtg-common.RateDetailsBanner.prePaymentLabel',
        defaultMessage: 'Monthly prepayment',
    },
    PREPAYMENT_TOOLTIP: {
        id: 'mtg-common.RateDetailsBanner.prePaymentTooltip',
        defaultMessage: `Prepayment options outline the flexibility you have to increase your monthly mortgage payments
            or make a lump sum outlay against your mortgage as a whole. According to the Canadian Association of Accredited Mortgage Professionals (CAAMP),
            28% of mortgage holders used one or both prepayment privileges in 2010.`,
    },
    LUMP_SUM_LABEL: {
        id: 'mtg-common.RateDetailsBanner.lumpSumLabel',
        defaultMessage: 'Lump sum prepayment',
    },
    PREAPPROVAL_LABEL: {
        id: 'mtg-common.RateDetailsBanner.preApprovalLabel',
        defaultMessage: 'Pre-approval',
    },
    PREAPPROVAL_VALUE: {
        id: 'mtg-common.RateDetailsBanner.preApprovalValue',
        defaultMessage: `{isPreApproval, select,
            true {Required}
            other {Not required}
        }`,
    },
    PROVIDER_URL_LABEL: {
        id: 'mtg-common.RateDetailsBanner.providerUrlLabel',
        defaultMessage: 'Visit website',
    },
    PROVIDER_RATE_TYPE_TERM: {
        id: 'mtg-common.RateDetailsBanner.typeTermLabel',
        defaultMessage: '{term} Year {type}',
    },
});
